import importedStyles from "../MetricsDashboard/Utilities/styles";

export const styles = {
    root: {
        // Generic styling
        ...importedStyles.root,

        // Page related
        backgroundColor: '#edede4',
        pt: 16,
        width: '100%',
        minHeight: '100vh',
    },
    container: {
        mx: 'auto',
        mt: '-50px',
        maxWidth: '100%',
        height: 'auto',
        position: 'relative',
        background: '#edede4',
    },

    hero: {
        width: '1344px',
        height: 'auto',
        margin: '0 auto',
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', md: 'center' },
        background: '#edede4',
        fontFamily: 'LarsseitRegular !important',
        fontSize: '14px !important',
        fontWeight: '500 !important',
        position: 'relative',
    },
    heading: {
        width: 'fit-content',
        fontWeight: '400',
        color: '#302E2A',
        justifyContent: 'flex-start',
        fontFamily: 'IvyPrestoHeadlineRegular',
        fontSize: '35px',
        lineHeight: '140%',
        letterSpacing: '0.03em',
        m: 0,
        position: 'relative',
        bottom: '3px'
    },
    backLink:{
        color: '#302E2A',
        position: 'relative',
        fontFamily: 'FustatBold',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'flex-end',
        gap: '20px',
    },
    arrowBack: {
        color: '#003300',
        marginRight:'8px',
        borderRadius: '0px',
        fontSize: '14px',
        position: 'absolute',
        left: '0',
        top: '3px'
    },
    footerLogin: {
        width: '100%',
        height: '60px',
        textAlign: 'left',
        fontSize: '13px',
        fontFamily: 'FustatRegular',
        fontWeight: '400',
        position: 'absolute',
        display: 'block',
        padding: '23px 48px',
    },
    tuneIcon: {
        width: '18px',
        height: '18px',
        flexShrink: 0,
        color: '#003300',
        pointerEvents: 'none',
        margin: '11px 10px 11px 5px',
    },
    arrowDownIcon: {
        fontSize: '26px!important',
        flexShrink: 0,
        color: '#003300',
        pointerEvents: 'none',
        borderRadius: '1px',
        position: 'absolute',
        right: '8px'
    },
    campaignsDropwdownButton: {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    campaignsDropwdownButtonText: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        flexGrow: 1,
        minWidth: 0
    }
}
